import React, { useState } from "react";
import { Button, Space } from "antd";

import QRScannerModal from "./QRScannerModal";

const TicketReader = () => {
  const [isQRReaderModalVisible, setIsQRReaderModalVisible] = useState(false);

  return (
    <div>
      <div style={{ marginBottom: "20px", textAlign: "center" }}>
        <Space>
          <Button
            type="primary"
            onClick={() => setIsQRReaderModalVisible(true)}
          >
            Leer QR
          </Button>
        </Space>
      </div>

      <QRScannerModal
        visible={isQRReaderModalVisible}
        setIsQRReaderModalVisible={setIsQRReaderModalVisible}
      />
    </div>
  );
};

export default TicketReader;
